import AjaxRequest from "../modules/ajax-request";
import Cookies from 'js-cookie';

class CheckUserLogged {
    constructor(element) {
        this._element = element;
        this._div = element[0] ?? element;
        this._id = "";
        this._urlCheckUserLogged = "";
        this._forceCheck = "";

        this.getData();
        this.clearData();
        this.init();
    }

    getData() {
        [this._id, this._urlCheckUserLogged, this._forceCheck] = Object.values(this._div.dataset);
    }

    clearData() {
        Object.keys(this._div.dataset).forEach(dataKey => {
            if (dataKey !== "id") {
                delete this._div.dataset[dataKey];
            }
        });
    }

    init() {
        if ((parseInt(Cookies.get("cs_logged")) === 1) || (this._forceCheck == 1)) {
            this.checkUserLogged();
        }
    }

    checkUserLogged() {
        let _ajaxRequest = new AjaxRequest({
            successCallback: function (data) {
                if (data.userLogged) {
                    let _event = new CustomEvent("user_logged");
                    document.dispatchEvent(_event);
                } else {
                    let _event = new CustomEvent("user_not_logged");
                    Cookies.remove("cs_logged");
                    Cookies.remove("cs_adv");
                    document.dispatchEvent(_event);
                }
            }
        });
        _ajaxRequest.makeCall(this._urlCheckUserLogged);
    }
}

export default CheckUserLogged